import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useEtsyListings = () => {
  const [listings, setListings] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/etsy/listings`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((data) => {
        if (!cancelled) setListings(data.results || []);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return listings;
};

export const matchListing = (listings, name) => {  const n = name.toLowerCase();
  return listings.find((l) => {
    const base = (l.title || "")
      .split("–")[0]
      .split("|")[0]
      .replace(/"[^"]*"/g, "")
      .toLowerCase()
      .trim();
    return base.includes(n) || (l.title || "").toLowerCase().includes(n);
  });
};

export const isDollyListing = (l) =>
  `${l.title} ${(l.tags || []).join(" ")}`.toLowerCase().includes("dolly");

const decode = (s) =>
  (s || "").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, "&");

const DOLLY_NOISE =
  /(custom shape|acrylic|led|usb|night\s?lights?|nightlights?|lamps?|personalized|engraved|uv|photo shape|shape|beech wood|wood base|plaque|print|lit\b|base|quote)/gi;

const dollyQuote = (t) => {
  const qm = t.match(/"([^"]+)"/);
  if (qm) return qm[1];
  let s = t.split("|")[0].split(":")[0];
  s = s.replace(/^Dolly Parton(?:\s+Tribute)?\s*/i, "");
  s = s.replace(DOLLY_NOISE, " ").replace(/\s+/g, " ").trim();
  return s.split(" ").length >= 3 ? s : "";
};

export const tributeItem = (l) => {
  const t = decode(l.title);
  const quote = dollyQuote(t);
  const isLight = /night\s?light|nightlight|lamp/i.test(t);
  const idMatch = (l.url || "").match(/listing\/(\d+)/);
  return {
    name: isLight ? "Tribute Night Light" : "Dolly Tribute Piece",
    key: idMatch ? `tribute-${idMatch[1]}` : undefined,
    phrase: quote ? `“${quote.replace(/^"|"$/g, "")}”` : "In honor of Dolly",
    url: l.url,
    liveState: l.state === "active" ? "active" : "soldout",
    livePrice:
      l.price && l.price.value != null ? `$${l.price.value.toFixed(2)} ${l.price.currency_code || "USD"}` : null,
    image: l.images && l.images.length > 0 ? l.images[0].url_570xN : null,
  };
};

export const withEtsy = (item, listings) => {
  const l = matchListing(listings, item.match || item.name);
  if (!l) return item;
  return {
    ...item,
    url: l.url,
    liveState: l.state || "active",
    livePrice:
      l.price && l.price.value != null
        ? `$${l.price.value.toFixed(2)} ${l.price.currency_code || "USD"}`
        : null,
    image: l.images && l.images.length > 0 ? l.images[0].url_570xN : null,
  };
};
